import { useState, useEffect, useMemo } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getMetabaseReportById } from "../API";
import ArrowLeft from "../assets/images/left-arrow.png";

const MetabaseReport = () => {
  const [dynamicReports, setDynamicReports] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const param = useParams();
  const [loading, setLoading] = useState(true);

  const qs = useMemo(() => {
    const queryParams = new URLSearchParams(location.search);
    const encodedPayload = queryParams.get("payload");

    if (!encodedPayload) {
      return "";
    }

    try {
      const payload = JSON.parse(atob(encodedPayload));
      const reportParams = new URLSearchParams();

      Object.entries(payload).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          reportParams.set(key, value);
        }
      });

      return reportParams.toString();
    } catch (error) {
      console.error("Error decoding report payload:", error);
      return "";
    }
  }, [location.search]);

const MyLoadingAnimation = ({ style }) => {
  return (
    <div
      className="flex items-center justify-center bg-white/80 z-10 w-full h-full"
      style={{ ...style, top: 0, left: 0, right: 0, bottom: 0 }}
    >
      <div className="flex flex-col items-center gap-3" style={{margin: "14% auto 0", display: "block", width: "max-content", textAlign: "center"}}>
        <span className="loaderx"></span>
        <p className="text-sm font-medium text-gray-600">Loading Report...</p>
      </div>
    </div>
  );
};

  useEffect(() => {
    const fetchReports = async () => {
      try {
        const data = await getMetabaseReportById(param?.id, qs);
        console.log(data.data);
        if (Array.isArray(data.data)) {
          setDynamicReports(data.data);
        } else if (data.data) {
          // Just in case the API returns a single object instead of an array
          setDynamicReports([data.data]);
        }
      } catch (error) {
        console.error("Error fetching metabase reports:", error);
      }
    };
    if (param?.id) {
      fetchReports();
    }
  }, [param?.id, qs]); // Added param?.id to dependency array



  // Get the URL from the first report in the array (if it exists)
  const reportUrl = dynamicReports.length > 0 ? dynamicReports[0].url : "";
  const reportTitle = dynamicReports.length > 0 ? dynamicReports[0].title : "";

  return (
    <div className="crew-mgmt flex flex-col">
      <button style={{"position": "fixed"}}
        className="btn btn-primary back-btn mb-3"
        onClick={() => navigate(-1)}
      >
        <img src={ArrowLeft} alt="Back" />
      </button>
      <div className="space-between-flex-container">
        <h1 className="title report" >{reportTitle}</h1>
      </div>
      <div className="flex-1" style={{height: "80vh", position: "relative"}}>
        {/* {  <MyLoadingAnimation style={{position: "absolute"}} /> } */}
        { loading ? <MyLoadingAnimation style={{position: "absolute"}} /> : <></> }
        {/* Only render the iframe if we have a valid URL */}
        {reportUrl ? (
          <iframe src={reportUrl} width={"100%"} height={"100%"} allowTransparency title="metabase-report-iframe"  onLoad={() => setLoading(false)} className="metabase-report-iframe"/>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default MetabaseReport;
